import React from 'react';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import { format } from 'date-fns';
import { CoreLink } from '@uncinc/react-drupal-core';
import Truncate from 'react-truncate';

import {
  SearchResults as DefaultSearchResults,
} from '@uncinc/react-searchkit';

import { useClearRefinements, useSearchBox } from 'react-instantsearch';

import { TYPE_NAME_MAPPING } from '../../containers/Search/config';

import './style.scss';

const Item = ({ hit }) => (
  <div className="Search__result_item">
    <CoreLink href={hit.url[0]}>
      <div className="row">
        <div className="col-12">
          <div className="Search__result_item__type">
            {TYPE_NAME_MAPPING[hit.aggregated_type[0]]}
          </div>
          <div className="Search__result_item__title">
            {hit.title?.[0] || hit.taxonomy_name?.[0]}
          </div>
          {(hit.body || hit.taxonomy_description) && (
            <div className="Search__result_item__body">
              <Truncate lines={2} ellipsis={<span>...</span>}>
                {hit.body?.[0] || hit.taxonomy_description?.[0]}
              </Truncate>
            </div>
          )}
          {hit.created && (
            <div className="Search__result_item__date">
              {format(new Date(hit.created[0] * 1000), 'd MMMM yyyy')}
            </div>
          )}
        </div>
      </div>
    </CoreLink>
  </div>
);

const SearchResults = () => {
  const { refine } = useClearRefinements();
  const { clear } = useSearchBox();

  return (
    <div className="SearchResults">
      <DefaultSearchResults
        renderItem={(hit) => <Item hit={hit} />}
        emptyState={(
          <div className="SearchResults__no_results">
            <h3 className="SearchResults__no_results__title">
              Geen resultaten gevonden bij de zoekopdracht
            </h3>
            <div className="SearchResults__no_results__body">
              Probeer een andere zoekterm of reset je filters.
            </div>
            <div className="SearchResults__no_results__action">
              <Button primary={false} className="Button--secondary" onClick={() => {
                clear(); // clear the search input.
                refine(); // clear the facets.
              }}>
                Reset filters
              </Button>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default SearchResults;
